class StartGuide extends HTMLElement {
  connectedCallback() {
    this.list = this.querySelector('.start-guide__list');
    this.cards = Array.from(this.querySelectorAll('.start-guide__card'));
    this.frame = null;

    if (!this.list || this.cards.length === 0) return;

    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);

    this.list.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize);
    this.updateActiveCard();
  }

  disconnectedCallback() {
    this.list?.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);

    if (this.frame) {
      window.cancelAnimationFrame(this.frame);
    }
  }

  onScroll() {
    if (this.frame) return;

    this.frame = window.requestAnimationFrame(() => {
      this.frame = null;
      this.updateActiveCard();
    });
  }

  onResize() {
    this.updateActiveCard();
  }

  updateActiveCard() {
    if (!window.matchMedia('(max-width: 600px)').matches) {
      this.clearActiveCard();
      return;
    }

    const listRect = this.list.getBoundingClientRect();
    const listCenter = listRect.left + listRect.width / 2;
    let activeCard = this.cards[0];
    let shortestDistance = Infinity;

    for (const card of this.cards) {
      const cardRect = card.getBoundingClientRect();
      const cardCenter = cardRect.left + cardRect.width / 2;
      const distance = Math.abs(cardCenter - listCenter);

      if (distance < shortestDistance) {
        activeCard = card;
        shortestDistance = distance;
      }
    }

    this.setActiveCard(activeCard);
  }

  setActiveCard(activeCard) {
    for (const card of this.cards) {
      const isActive = card === activeCard;

      card.classList.toggle('is-active', isActive);
      if (isActive) {
        card.setAttribute('aria-current', 'true');
      } else {
        card.removeAttribute('aria-current');
      }
    }
  }

  clearActiveCard() {
    for (const card of this.cards) {
      card.classList.remove('is-active');
      card.removeAttribute('aria-current');
    }
  }
}

if (!customElements.get('start-guide')) {
  customElements.define('start-guide', StartGuide);
}
